module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.RELEASE_MANAGEMENT_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3008' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] RELEASE_MANAGEMENT_URL not configured for production');
            reject(new Error('Release Management MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.releaseManagement);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load releaseManagement remote from:', remoteUrl);
            reject(new Error('Failed to load Release Management MFE'));
          };
          document.head.appendChild(script);
        });